import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  uuid: PropTypes.string,
  refId: PropTypes.string,
  currency: PropTypes.string,
  currencyRate: PropTypes.string,
  reference: PropTypes.string,
  externalReference: PropTypes.string,
  refundAvailable: PropTypes.bool,
  provider: PropTypes.string,
  method: PropTypes.string,
  amount: PropTypes.number,
  amountInOriginalCurrency: PropTypes.number,
  availableRefundAmount: PropTypes.number,
  transactionTimestamp: PropTypes.string,
  refundProcessTimestamp: PropTypes.string,
  paymentStatus: PropTypes.string
});
